import { TReduxActions } from '../../actions';
import { EFetchMapDataActionType } from '../../actions/fetchMapData/types';
import { EMapBoundsActionType } from '../../actions/mapBounds';
import { toFiltersUrl } from '../../mappers/queryString';
import { UrlWithBoundsBuilder } from '../../utils/urlWithBoundsBuilder';

export function filtersUrlReducer(state: string = '#', action: TReduxActions): string {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed:
      if (action.payload.clean) {
        return toFiltersUrl(action.payload.queryString);
      }

      return state;
    case EMapBoundsActionType.Changed:
      return new UrlWithBoundsBuilder(state, action.payload).withCenter().withZoom().build();
    default:
      return state;
  }
}
